"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const utilityverifiedsm = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-utilityverifiedsm` : '') + (description ? ` desc-utilityverifiedsm` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-utilityverifiedsm"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-utilityverifiedsm"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.51 2.19c.28-.25.7-.25.98 0l1.93 1.78c.15.14.37.2.58.18l2.66-.36c.38-.05.73.2.8.58l.45 2.46c.04.22.18.4.38.5l2.32 1.18c.35.18.5.6.31.96l-1.13 2.2c-.1.2-.1.45 0 .65l1.13 2.21c.18.35.04.79-.31.96l-2.32 1.17c-.2.1-.34.3-.38.51l-.45 2.46a.72.72 0 0 1-.8.58L15 19.85a.72.72 0 0 0-.58.18l-1.93 1.78a.72.72 0 0 1-.98 0l-1.93-1.78a.72.72 0 0 0-.58-.18l-2.66.36a.72.72 0 0 1-.8-.58l-.45-2.46a.71.71 0 0 0-.38-.5l-2.32-1.18a.71.71 0 0 1-.31-.96l1.13-2.2c.1-.2.1-.45 0-.66l-1.13-2.2a.71.71 0 0 1 .31-.96l2.32-1.17c.2-.1.34-.3.38-.51l.45-2.46a.72.72 0 0 1 .8-.58L9 4.15c.21.03.43-.04.58-.18l1.93-1.78Zm5.03 6.51a1.08 1.08 0 0 0-1.51-.03l-4.65 4.42-1.41-1.35a1.08 1.08 0 0 0-1.52.04c-.41.43-.4 1.1.03 1.51l2.16 2.05c.41.4 1.07.4 1.48 0l5.39-5.13c.43-.4.44-1.08.03-1.5Z",
    fill: "#0E3AC9"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.9 6.82c.04.22.19.41.38.51L21.6 8.5c.36.18.5.61.32.96l-1.14 2.21c-.1.2-.1.45 0 .65l1.14 2.2c.18.36.04.79-.32.97l-2.32 1.17c-.2.1-.34.29-.38.5l-.45 2.46a.72.72 0 0 1-.8.58L15 19.84a.72.72 0 0 0-.58.19l-1.93 1.77a.72.72 0 0 1-.97 0l-1.93-1.77a.72.72 0 0 0-.58-.19l-2.66.36a.72.72 0 0 1-.8-.58l-.23-1.26 3.75-3.57.58.55c.41.4 1.07.4 1.48 0l5.39-5.13a1.07 1.07 0 0 0-.7-1.84l2.87-2.74.22 1.2Z",
    fill: "#0E3AC9"
  }));
};
var _default = exports.default = utilityverifiedsm;